import { useState, useEffect } from "react";

const ZoomLevelProvider = ({ onZoomChange }) => {
  useEffect(() => {
    const handleZoom = () => {
      const zoom = Math.round((window.outerWidth / window.innerWidth) * 100);
      if (onZoomChange) {
        onZoomChange(zoom); // Send zoom level to parent
      }
    };

    handleZoom();
    window.addEventListener("resize", handleZoom);

    return () => {
      window.removeEventListener("resize", handleZoom);
    };
  }, [onZoomChange]);

  return null; // This component does not render anything
};

export default ZoomLevelProvider;
